module.exports = __webpack_public_path__ + "static/media/INB.3d1adf86.svg";